/**
 * Only a tap can open the app here, so nothing happens on its own. See
 * lib/inAppEscape/appBounce.ts.
 */
export function RedirectAppOpenOnTap() {
  return (
    <p
      className={`
        mb-4 w-70 text-center text-sm text-slate-500
        system-dark:text-zinc-400
      `}
    >
      Tap the button below to open the app.
    </p>
  );
}
